import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import TextInput from '../../containers/Forms/components/TextInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import ReactMultiSelectDropdownInput from '../../containers/Forms/components/ReactMultiSelectDropdownInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import ESignatureModal from '../../../views/components/Modal/ESignatureModal'
import AlertBar from '../../../views/components/Common/AlertBar'
import { getName, getPrescriptionOptionLabel } from '../../containers/Utilities'
import {
  ALL_RECORDINGS_TRIGGER_OPTION,
  CUSTOM_TRIGGER_OPTION,
  getPrimaryTriggerOptions,
  getTriggerDisplayTranslatedText,
  TRIAGE_OPTION,
} from '../../constants'
import CheckboxInput from '../../containers/Forms/components/CheckboxInput'
import { requiredValidation, emailMask, emailValidation, minLen1Validation } from '../../containers/Forms/components/formValidations'
import styles from './Forms.css'
import Number1 from 'static/images/number-1.svg'
import Number2 from 'static/images/number-2.svg'
import Number3 from 'static/images/number-3.svg'
import Loading from '../../components/Loading'
import { filterPrescriptionCanBePrescribed, filterBillingCodesCanBeBillable, showEsignModal, clearEsignInfo } from '../../store/appReducer'
import { FormattedMessage, useIntl } from 'react-intl'
import { checkESignaureFeatureEnabled } from '../../../configs'
import { ALERT_MSG, ALERT_SEVERITY, ALERT_STYLE, ESIGN_MODAL_NAME } from '../../../views/components/Common/AlertBar/Constants'

const PrescribeForm = props => {
  const {
    handleSubmit,
    prescribeFormData,
    physicians,
    prescriptions,
    triggers,
    invalid,
    pristine,
    submitting,
    billingCodes,
    icd10Codes,
    isSubmitting,
    me,
    isLicenseManagementEnabled,
  } = props

  const intl = useIntl()

  let physiciansOptions = [
    TRIAGE_OPTION,
  ]
  let prescriptionOptions = []
  let triggerOptions = []
  let billingOptions = []
  let icd10Options = []

  if (physicians && physicians.data) {
    physiciansOptions = [ ...physiciansOptions, ...physicians.data.sortedByLastName.map(id => physicians.data.byId[id]) ]
  }

  if (prescriptions && prescriptions.data) {
    prescriptionOptions = [ ...prescriptionOptions, ...filterPrescriptionCanBePrescribed(prescriptions.data.source) ]
  }

  if (triggers && triggers.data) {
    triggerOptions = [ ...triggerOptions, ...getPrimaryTriggerOptions(triggers.data) ]
  }

  if (billingCodes && billingCodes.data) {
    billingOptions = [ ...billingOptions, ...filterBillingCodesCanBeBillable(billingCodes.data.sortedByName.map(id => billingCodes.data.byId[id])) ]
  }

  if (icd10Codes && icd10Codes.data) {
    icd10Options = [ ...icd10Options, ...icd10Codes.data.sortedByName.map(id => icd10Codes.data.byId[id]) ]
  }

  const isCustomSelected = prescribeFormData && prescribeFormData.ekgReviewWhichRecordings && prescribeFormData.ekgReviewWhichRecordings.id === CUSTOM_TRIGGER_OPTION.id
  let isPossibleAFibResultWithHrCheckmarked = false
  let isHeartRateUnderCheckmarked = false
  let isHeartRateOverCheckmarked = false
  let isIDTFPlanChecked = false

  if (prescribeFormData) {
    if (prescribeFormData.custom) {
      const {
        custom,
      } = prescribeFormData

      isPossibleAFibResultWithHrCheckmarked = custom.possibleAFibResultWithHrCheckmark
      isHeartRateUnderCheckmarked = custom.heartRateUnderCheckmark
      isHeartRateOverCheckmarked = custom.heartRateOverCheckmark
    }
    // Checking whether IDTF is true or not
    isIDTFPlanChecked = prescribeFormData.prescriptionPlan && prescribeFormData.prescriptionPlan.isIDTF
  }

  let idtfTemplate = true
  idtfTemplate = isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked

  const { teamPatientFields } = ((((me || {}).data || {}).teams || {})[0] || { teamPatientFields: [] })
  const teamPatientFieldsConfigforEmail = teamPatientFields.find(fieldConfig => fieldConfig.fieldName === 'email') || {}

  let emailValidationFunctions = ''

  // if the selected connection plan is idtf no validation is required
  // if the selected connection plan is non-idtf, add the validations based on team patient field config for email field

  if (!idtfTemplate) {
    if (teamPatientFieldsConfigforEmail.isRequired) {
      emailValidationFunctions = [ emailValidation, minLen1Validation, requiredValidation ]
    } else {
      emailValidationFunctions = [ emailValidation ]
    }
  }

  const dispatch = useDispatch()
  const isEsignModalOpen = useSelector(state => state.app.isEsignModalOpen)
  const isEsigned = useSelector(state => state.app.esignInfo.isEsigned)
  const esignModalName = useSelector(state => state.app.esignModalName)

  // check if E-signaure feature is enabled and esign modal is opened

  const isEsignaureEnabled = checkESignaureFeatureEnabled(me)

  /* on submiting the form show the esignaure modal,
     if the e-signaure (CFR21 Part11 Audit trail) feature is enabled
     else proceed with submiting the form
  */
  const handleEsingnatureModal = e => {
    e.preventDefault()
    if (isEsignaureEnabled) {
      dispatch(showEsignModal(ESIGN_MODAL_NAME.ORDER_CREATION))
    } else {
      handleSubmit()
    }
  }

  return (
    <React.Fragment>
      {/* show alert message on success */}
      {isEsigned &&
      esignModalName === ESIGN_MODAL_NAME.ORDER_CREATION ? (
          <AlertBar
            severity={ALERT_SEVERITY.SUCCESS}
            message={ALERT_MSG[esignModalName]}
            overridestyle={ALERT_STYLE.SUCCESS}
            autoClose
            autoCloseDelay={5000}
            onClickClose={() => {
              dispatch(clearEsignInfo)
            }}
          />
        ) : null}

      {// Render EsignatureModal component if fr-21-11-audit-trail featue is enabled
        isEsignaureEnabled ? (
          <ESignatureModal
            open={isEsignModalOpen}
            formTitle={<FormattedMessage id="heading.profile_update" />}
            confirmHandler={handleSubmit}
            screenName={ESIGN_MODAL_NAME.ORDER_CREATION}
          />
        ) : null}
      <div className={styles.prescribeContainer}>
        <form onSubmit={handleEsingnatureModal}>
          <div className={styles.prescribeSection}>
            {isLicenseManagementEnabled ? (
              <React.Fragment>
                <h2><FormattedMessage id="heading.Connection_Period" /></h2>
                <div className={styles.label}><FormattedMessage id="label.connection_period" /></div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <h2><FormattedMessage id="heading.Connection_Plan" /></h2>
                <div className={styles.label}><FormattedMessage id="label.connection_plan" /></div>
              </React.Fragment>
            )}
            <div className={styles.prescribeStep}>
              <span><FormattedMessage id="label.step"/></span>
              <Number1 />
            </div>
            <div className={styles.prescribeBorder}>
              {isLicenseManagementEnabled ? (
                <React.Fragment>
                  <Field
                    component={ReactSelectDropdownInput}
                    name="rpmDuration"
                    isClearable={false}
                    backspaceRemovesValue={false}
                    placeholder={<FormattedMessage id="placeholder.rpmDuration" />}
                    // options are 30days 60days 90days ... multiples of 30 till 360 days
                    options={[ ...Array(12).keys() ].map(i => ({
                      id: (i + 1) * 30,
                      name: `${(i + 1) * 30} ${intl.formatMessage({ id: 'label.days' })}`,
                    }))}
                    noOptionsMessage={<FormattedMessage id="notfound.rpmDuration" />}
                    getOptionLabel={p => p.name}
                    getOptionValue={p => p.id}
                    validate={requiredValidation}
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Field
                    component={ReactSelectDropdownInput}
                    name="prescriptionPlan"
                    isLoading={prescriptions && prescriptions.isFetching}
                    isClearable={false}
                    backspaceRemovesValue={false}
                    placeholder={<FormattedMessage id="placeholder.prescriptionPlan" />}
                    options={prescriptionOptions}
                    noOptionsMessage={<FormattedMessage id="notfound.connection_plan" />}
                    getOptionLabel={getPrescriptionOptionLabel}
                    getOptionValue={p => p.id}
                    validate={requiredValidation}
                  />
                </React.Fragment>
              )}
              {
                // Email field should be visible only if the idtfTemplate is selected or in case of non-idtf template (RPM)
                // the visibility should be handled based on Patient Filed config(KPA).
                (idtfTemplate || teamPatientFieldsConfigforEmail.isVisible) &&
                <Field
                  component={MaskedInput}
                  mask={emailMask}
                  placeholder={intl.formatMessage({
                    id: 'placeholder.patient_email_address'
                  })}
                  name="email"
                  validate={[ ...emailValidationFunctions ]}
                />
              }
            </div>
          </div>
          <div className={styles.prescribeSection}>
            <h2><FormattedMessage id="heading.Reports_and_Billing" /></h2>
            <div className={styles.label}><FormattedMessage id="label.report_billing" /></div>
            <div className={styles.prescribeStep}>
              <span><FormattedMessage id="label.step" /></span>
              <Number2 />
            </div>
            <div className={styles.prescribeBorder}>
              {/* MultiSelect Dropdown in case of IDTF */}
              {isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked ?
                <React.Fragment>
                  <Field
                    component={ReactMultiSelectDropdownInput}
                    name="icd10Codes"
                    enableSearch={true}
                    selected={icd10Codes}
                    isLoading={icd10Codes && icd10Codes.isFetching}
                    placeholder={<FormattedMessage id="placeholder.icd10Codes" />}
                    options={icd10Options}
                    noOptionsMessage={<FormattedMessage id="notfound.icd10Codes" />}
                    getOptionLabel={p => {
                      let label = p.id
                      if (p.name) {
                        label += ` - ${p.name}`
                      }
                      return label
                    }}
                    getOptionValue={p => p.id}
                  />
                </React.Fragment> :
                <Field
                  component={ReactSelectDropdownInput}
                  name="icd10Codes"
                  isLoading={icd10Codes && icd10Codes.isFetching}
                  placeholder={<FormattedMessage id="placeholder.icd10Codes" />}
                  options={icd10Options}
                  noOptionsMessage={<FormattedMessage id="notfound.icd10Codes" />}
                  getOptionLabel={p => {
                    let label = p.id
                    if (p.name) {
                      label += ` - ${p.name}`
                    }
                    return label
                  }}
                  getOptionValue={p => p.id}
                />
              }
              <Field
                component={ReactSelectDropdownInput}
                name="billingCodes"
                isLoading={billingCodes && billingCodes.isFetching}
                placeholder={<FormattedMessage id="placeholder.billingCodes" />}
                options={billingOptions}
                disabled={isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked}
                noOptionsMessage={<FormattedMessage id="notfound.icd10Codes" />}
                getOptionLabel={p => {
                  let label = p.name
                  if (p.description) {
                    label += ` - ${p.description}`
                  }
                  return label
                }}
                getOptionValue={p => p.id}
              />
              <Field
                component={TextInput}
                placeholder={intl.formatMessage({
                  id: 'placeholder.orderNumber'
                })}
                name="orderNumber"
                disabled={isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked}
              />
            </div>
          </div>
          <div className={(isIDTFPlanChecked !== undefined && isIDTFPlanChecked !== null && isIDTFPlanChecked) ? styles.prescribeSectionGrey : styles.prescribeSection}>
            <h2><FormattedMessage id="heading.Team_Inbox_Settings" /></h2>
            <div className={styles.label}><FormattedMessage id="label.inbox_settings" /></div>
            <div className={styles.prescribeStep}>
              <span><FormattedMessage id="label.step" /></span>
              <Number3 />
            </div>
            <div className={styles.prescribeBorder}>
              <Field
                component={ReactSelectDropdownInput}
                placeholder="Placeholder"
                name="ekgReviewWhichRecordings"
                isLoading={triggers && triggers.isFetching}
                isClearable={false}
                backspaceRemovesValue={false}
                options={triggerOptions}
                noOptionsMessage={<FormattedMessage id="notfound.recording_type" />}
                getOptionLabel={p => getTriggerDisplayTranslatedText(p.type || p.label)}
                getOptionValue={p => p.id}
              />
              {isCustomSelected &&
                (
                  <div className={styles.customRules}>
                    <h3><FormattedMessage id="heading.custom_rules" /></h3>
                    <Field
                      component={CheckboxInput}
                      label="Possible AFib result"
                      name="custom.possibleAFibResultCheckmark"
                    />
                    <Field
                      component={TextInput}
                      type="number"
                      inline
                      disabled={!isPossibleAFibResultWithHrCheckmarked}
                      getLabel={() => (
                        <Field
                          component={CheckboxInput}
                          className={styles.checkboxGroupFixedWidth}
                          label="Possible AFib result with heart rate over"
                          name="custom.possibleAFibResultWithHrCheckmark"
                        />
                      )}
                      name="custom.possibleAFibResultWithHr"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Sinus Rhythm with Wide QRS"
                      name="custom.sinusRhythmWithWideQRS"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Sinus Rhythm with SVE"
                      name="custom.sinusRhythmWithSVEs"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Sinus Rhythm with PVCs"
                      name="custom.sinusRhythmWithPVCs"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Tachycardia"
                      name="custom.tachycardia"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Bradycardia"
                      name="custom.bradycardia"
                    />
                    <Field
                      component={CheckboxInput}
                      label="Unclassified result"
                      name="custom.unclassifiedResultCheckmark"
                    />
                    <Field
                      component={TextInput}
                      type="number"
                      inline
                      disabled={!isHeartRateUnderCheckmarked}
                      getLabel={() => (
                        <Field
                          component={CheckboxInput}
                          className={styles.checkboxGroupFixedWidth}
                          label="Heart rate under"
                          name="custom.heartRateUnderCheckmark"
                        />
                      )}
                      name="custom.heartRateUnder"
                    />
                    <Field
                      component={TextInput}
                      type="number"
                      inline
                      disabled={!isHeartRateOverCheckmarked}
                      getLabel={() => (
                        <Field
                          component={CheckboxInput}
                          className={styles.checkboxGroupFixedWidth}
                          label="Heart rate over"
                          name="custom.heartRateOverCheckmark"
                        />
                      )}
                      name="custom.heartRateOver"
                    />
                  </div>
                )
              }
              <Field
                component={ReactSelectDropdownInput}
                placeholder={<FormattedMessage id="label.Flagged_Recordings_Go_to" />}
                name="ekgReviewWhereRecordings"
                isLoading={physicians && physicians.isFetching}
                isClearable={false}
                backspaceRemovesValue={false}
                options={physiciansOptions}
                noOptionsMessage={<FormattedMessage id="notfound.ekgReviewWhereRecordings" />}
                getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
                getOptionValue={p => p.id}
              />
            </div>
          </div>
          <div className={styles.prescribeSubmitWrapper}>
            <div className={styles.buttonWrapper}>
              {submitting || isSubmitting ?
                <button disabled className={styles.submitLoading}>
                  <Loading />
                </button>
                :
                <button
                  type="submit"
                  disabled={invalid || pristine}
                  className={styles.submit}
                  data-action="button-prescribe-plan"
                  data-label="order"
                >
                  <FormattedMessage id="button.order" />
                </button>
              }
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  )
}

export default reduxForm({
  form: 'prescribeForm',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(PrescribeForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/PrescribeForm.jsx